import { z } from 'zod';

export const activeTotalsSchema = z.object({
  active: z.number(),
  inactive: z.number(),
});

export type ActiveTotals = z.infer<typeof activeTotalsSchema>;
